import * as React from 'react';

export interface RadioGroupContextValue {
  disabled?: boolean;
  name: string | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  value: any;
}

const RadioGroupContext = React.createContext<RadioGroupContextValue | undefined>(undefined);

export default RadioGroupContext;
